module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Ge-Hc-Ic-Jb.b2b61861.png";